import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react-hooks/exhaustive-deps */
import { BackdropLoader, Box, Icon, PageTabs, TableLoader } from '@livable/saas-react-components';
import { Container, IconButton, Paper } from '@mui/material';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import AllocationsSummary from 'src/components/allocations/AllocationsSummary';
import BreadcrumbsBar from 'src/components/general/BreadcrumbsBar';
import Separator from 'src/components/general/Separator';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { useStore } from 'src/stores';
import { sortCycles } from 'src/utils/date';
import { useBatch } from 'src/utils/hooks';
import AllocationHistoryModal from './AllocationHistoryModal';
import ConfirmTableClosingModal from './ConfirmTableClosingModal';
import AllocationsActionBar from './AllocationsActionBar';
import AllocationUtility from './AllocationUtility';
import AllocationSubmeteredUtility from './AllocationSubmeteredUtility';
import CorrectionsTable from './AllocationUtility/CorrectionsTable';
import ReportCredentialsIssueModal from './ReportCredentialsIssueModal';
import useStyles from './styles';
const AllocationTablesPage = observer(() => {
  var _tablePreview$utility, _tablePreview$utility2;
  const classes = useStyles();
  const history = useLocation();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const urlParams = new URLSearchParams(history.search);
  const allocationCycleId = urlParams.get('allocationCycleId');
  const fromHistory = urlParams.get('fromHistory') === 'true';
  const propertyId = urlParams.get('propertyId');
  const queue = store.allocations.queue;
  const selectedBillingCycleId = store.allocations.selectedBillingCycleId;
  const tablePreview = store.allocations.tablePreview.get(selectedBillingCycleId) || {};
  const utilityTables = ((_tablePreview$utility = tablePreview.utilityTables) === null || _tablePreview$utility === void 0 ? void 0 : _tablePreview$utility.filter(ut => ut.allocationMethod !== 'BySubmeter').sort((a, b) => a.utilityId - b.utility)) || [];
  const submeteredUtilityTables = ((_tablePreview$utility2 = tablePreview.utilityTables) === null || _tablePreview$utility2 === void 0 ? void 0 : _tablePreview$utility2.filter(ut => ut.allocationMethod === 'BySubmeter').sort((a, b) => a.utilityId - b.utility)) || [];
  const batchQueue = store.allocations.batchQueue;
  const allocationBatchId = batchQueue[0];
  const isTableLoading = store.allocations.isTableLoading;
  const propertyAddress = store.allocations.propertyAddress.get(propertyId);
  const setIsTableLoading = store.allocations.setIsTableLoading;

  // const [expanded, setExpandedFirstItem] = useState(
  //   localStorage.getItem('livable_allocation_tables_wizard_is_shown') === null ? true : false
  // );

  const expanded = localStorage.getItem('livable_allocation_tables_wizard_is_shown') === null ? true : false;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    addTable = _useState2[0],
    setAddTable = _useState2[1];
  const _useState3 = useState('property'),
    _useState4 = _slicedToArray(_useState3, 2),
    currentCycleName = _useState4[0],
    setCurrentCycleName = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    deleteTableId = _useState6[0],
    setDeleteTableId = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoading = _useState8[0],
    setIsLoading = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isMounted = _useState0[0],
    setIsMounted = _useState0[1];
  const _useState1 = useState(0),
    _useState10 = _slicedToArray(_useState1, 2),
    lastIndex = _useState10[0],
    setLastIndex = _useState10[1];
  // const [priorCycles, setPriorCycles] = useState([]);
  const _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    tableId = _useState12[0],
    setTableId = _useState12[1];
  const _useState13 = useState([{
      label: t('allocations.current_billing_cycle'),
      value: allocationCycleId
    }]),
    _useState14 = _slicedToArray(_useState13, 2),
    tabs = _useState14[0],
    setTabs = _useState14[1];
  const disabled = isLoading || store.activity.getBatchAsync.inProgress || store.allocations.getAllocationTableAggregateAsync.inProgress || store.allocations.deleteBillingCycleAsync.inProgress;
  const getAddBillingCycle = async data => {
    const resp = await store.allocations.getAddBillingCycleAsync.run(data);
    return resp;
  };
  const getAllocationPreview = async data => {
    const resp = await store.allocations.getAllocationPreviewAsync.run(data);
    return resp;
  };
  const getAllocationTable = async data => {
    const resp = await store.allocations.getAllocationTableAggregateAsync.run(data);
    return resp;
  };
  const getBillingCycles = async data => {
    const resp = await store.allocations.getBillingCyclesAsync.run(data);
    return resp;
  };
  const getCompanyProperties = async () => {
    const resp = await store.company.getCompanyPropertiesAsync.run();
    return resp;
  };
  const getAllocationsHistory = async data => {
    const resp = await store.allocations.getAllocationsHistoryAsync.run(data);
    return resp;
  };

  // ! Not used
  // const getSkippedCycles = async data => {
  //   const resp = await store.allocations.getSkippedCyclesAsync.run(data);
  //   return resp;
  // };

  const getCorrectionsDetails = async () => {
    const resp = await store.corrections.getCorrectionsDetailsAsync.run({
      allocationCycleId,
      propertyId
    });
    return resp;
  };
  const getCurrentCycle = async data => {
    const resp = await store.allocations.getCurrentCycleAsync.run(data);
    return resp;
  };
  const deleteBillingCycle = async data => {
    const resp = await store.allocations.deleteBillingCycleAsync.run(data);
    return resp;
  };
  const getUtilityInfo = async ids => {
    if (!store.account.featureFlagsStore.getIsBillAutomationEnabled || !store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
      const resp = await store.utilityProviders.getUtilityInfoAsync.run({
        utilityIds: ids
      });
      return resp;
    } else {
      const resp = await store.utilityProviders.getPropertyUtilityInfoAsync.run({
        utilityIds: ids,
        propertyId: propertyId
      });
      return resp;
    }
  };
  const transformCycles = c => ({
    id: c.id,
    name: c.name,
    ym: "".concat(c.year).concat(c.month.toString().padStart(2, '0')) * 1
  });
  const removeTab = (value, event) => {
    setTableId(value);
    event.stopPropagation();
  };

  // const handleWizardSteps = step => {
  //   if (step > 0) {
  //     setExpandedFirstItem(true);
  //   } else {
  //     setExpandedFirstItem(false);
  //   }
  // };

  const closeIconButton = value => /*#__PURE__*/React.createElement(IconButton, {
    component: "span",
    disableFocusRipple: true,
    disableRipple: true,
    onClick: e => removeTab(value, e),
    variant: "closeTabAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    svgType: "tabClose",
    type: "close"
  }));
  const initialPromises = () => [getAllocationPreview({
    billingCycleId: selectedBillingCycleId,
    propertyId
  }).then(reps => {
    var _reps$response;
    const ids = reps === null || reps === void 0 || (_reps$response = reps.response) === null || _reps$response === void 0 || (_reps$response = _reps$response.utilityTables) === null || _reps$response === void 0 ? void 0 : _reps$response.map(u => u.utilityId);
    if ((ids === null || ids === void 0 ? void 0 : ids.length) > 0) return getUtilityInfo(ids);
  }), getCompanyProperties(), getAllocationsHistory({
    companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
  }),
  // getSkippedCycles({
  //   propertyId,
  // }),

  getCurrentCycle({
    companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
  }), store.account.featureFlagsStore.allocationCorrectionEnabled ? getCorrectionsDetails() : Promise.resolve()];
  const getPromises = (promises, callback) => Promise.all([...promises]).then(async () => {
    var _store$allocations$hi;
    if (isMounted) return;
    store.files.getFileUploadingAccepted();
    const cName = (_store$allocations$hi = store.allocations.history.find(cycle => cycle.id === allocationCycleId)) === null || _store$allocations$hi === void 0 ? void 0 : _store$allocations$hi.name;
    setCurrentCycleName(cName);
    const months = store.allocations.history.map(transformCycles).sort(sortCycles).map(c => {
      const name = c.name.substring(0, c.name.indexOf(' '));
      store.allocations.setCyclesId(name, c.id);
      return name;
    });
    store.allocations.setTabs(months.slice(0, 6));

    // const priors = store.allocations.skippedCycles.map(transformCycles).sort(sortCycles);
    // setPriorCycles(priors);
  }).then(async () => {
    const property = store.company.propertiesList.find(p => p.propertyId === propertyId);
    store.allocations.setPropertyAddress(propertyId, property === null || property === void 0 ? void 0 : property.propertyAddress);
    if (!store.allocations.tablePreview.get(selectedBillingCycleId)) await getAllocationPreview({
      billingCycleId: selectedBillingCycleId,
      propertyId
    });
  }).finally(callback);
  useBatch(allocationBatchId, async () => {
    if (selectedBillingCycleId === 'initial') return;
    const utilityId = store.allocations.allocationBatchIdForUtility.get(allocationBatchId);
    if (utilityId) {
      const id = allocationBatchId + selectedBillingCycleId + propertyId + utilityId;
      store.allocations.addToQueue({
        billingCycleId: selectedBillingCycleId,
        id,
        propertyId,
        utilityId
      });
      store.allocations.deleteAllocationBatchIdForUtility(allocationBatchId);
    }
    store.allocations.addToQueue({
      billingCycleId: selectedBillingCycleId,
      id: allocationBatchId + selectedBillingCycleId + propertyId,
      propertyId
    });
  }, () => {}, () => {
    store.allocations.removeFromQueueBatch(allocationBatchId);
    store.allocations.addBatched(allocationBatchId);
  }, t('allocations.table_fetch_error'));
  useEffect(() => {
    return () => {
      store.allocations.setSelectedBillingCycleId('initial');
    };
  }, []);
  useEffect(() => {
    if (selectedBillingCycleId === 'initial') {
      setIsLoading(true);
      getBillingCycles({
        allocationCycleId,
        propertyId
      }).then(async resp => {
        const _resp$response = _slicedToArray(resp.response, 1),
          billingCycle = _resp$response[0];
        const selectedCycle = toJS(store.allocations.history.find(cycle => cycle.id === billingCycle.allocationCycleId));
        const cycleMonthName = selectedCycle && selectedCycle.name !== 'undefined' ? selectedCycle.name.toString().split(' ')[0] : undefined;
        const billingCycles = [...resp.response].sort((a, b) => {
          if (a.isDefault && !b.index) return -1;
          return 1;
        }).map((c, count) => ({
          icon: c.isDefault || fromHistory ? undefined : closeIconButton(c.id),
          iconPosition: 'end',
          isDefault: c.isDefault,
          id: c.id,
          index: c.isDefault ? 0 : count,
          label: c.isDefault ? !!cycleMonthName ? t('allocations.month_billing_cycle', {
            cycleMonthName
          }) : t('allocations.current_billing_cycle') : t('allocations.additional_table', {
            count
          }),
          value: c.id
        })).sort((a, b) => {
          if (a.index > b.index) return -1;
          return 1;
        });
        if (billingCycles.length > 1) billingCycles.reverse();
        store.allocations.setSelectedBillingCycleId(billingCycles[0].id);
        setLastIndex(billingCycles.length);
        setTabs([...billingCycles]);
      }).finally(() => {
        setIsLoading(false);
      });
    }
  }, [selectedBillingCycleId]);
  useEffect(() => {
    if (selectedBillingCycleId === 'initial') return;
    setIsTableLoading(true);
    getPromises([...(isMounted ? [] : initialPromises())], () => {
      setIsMounted(true);
      setIsTableLoading(false);
    });
    if (!store.allocations.summary.get(store.allocations.selectedBillingCycleId)) store.allocations.addToQueue({
      billingCycleId: selectedBillingCycleId,
      id: selectedBillingCycleId + propertyId,
      propertyId
    });
  }, [selectedBillingCycleId]);
  useEffect(() => {
    if (queue.length > 0 && !store.allocations.getAllocationTableAggregateAsync.inProgress) getAllocationTable({
      billingCycleId: queue[0].billingCycleId,
      propertyId,
      utilityId: queue[0].utilityId
    }).then(() => store.allocations.removeFromQueue(queue[0]));
  }, [queue]);
  useEffect(() => {
    if (batchQueue.length > 0 && !store.activity.getBatchAsync.inProgress) store.allocations.setAllocationBatchId(batchQueue[0].id);
  }, [batchQueue]);
  useEffect(() => {
    if (addTable) {
      setIsTableLoading(true);
      getAddBillingCycle({
        allocationCycleId,
        propertyId
      }).then(resp => {
        if (resp && resp.isSuccessful) {
          setTabs([...tabs, {
            icon: closeIconButton(resp.response.id),
            iconPosition: 'end',
            isDefault: false,
            id: resp.response.id,
            label: t('allocations.additional_table', {
              count: lastIndex
            }),
            value: resp.response.id
          }]);
          store.allocations.setSelectedBillingCycleId(resp.response.id);
          setLastIndex(lastIndex + 1);
        }
      }).finally(() => {
        setAddTable(false);
        setIsTableLoading(false);
      });
    }
  }, [addTable]);
  useEffect(() => {
    if (deleteTableId) {
      setIsTableLoading(true);
      deleteBillingCycle({
        billingCycleId: deleteTableId,
        propertyId
      }).then(resp => {
        if (resp.isSuccessful) {
          const newTabs = [...tabs.filter(tab => tab.value !== deleteTableId)];
          const index = tabs.findIndex(tab => tab.value === deleteTableId);
          if (index === tabs.length - 1) setLastIndex(lastIndex - 1);
          if (deleteTableId === selectedBillingCycleId) {
            store.allocations.setSelectedBillingCycleId(tabs[index - 1].value);
          }
          setTabs([...newTabs]);
        }
      }).finally(() => {
        setDeleteTableId(null);
        setIsTableLoading(false);
      });
    }
  }, [deleteTableId]);
  const breadcrumbsBarArray = [{
    title: fromHistory ? t('allocations.allocation_history') : t('allocations.allocations'),
    link: fromHistory ? '/allocations/allocations_history' : '/allocations'
  }, {
    link: "/residencies?id=".concat(propertyId, "&tab=residencies"),
    title: "".concat(propertyAddress || t('add_new_property_flow.building_addresses'))
  }, {
    title: t('allocations.allocation_tables_for', {
      currentCycleName: currentCycleName || t('allocations.property')
    })
  }];
  const handleSelectedTabChange = (e, value) => store.allocations.setSelectedBillingCycleId(value);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading ? /*#__PURE__*/React.createElement(Paper, {
    className: classes.breadcrumbsBarPaper
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  })) : /*#__PURE__*/React.createElement(BreadcrumbsBar, {
    breadcrumbsArray: breadcrumbsBarArray,
    helpTopic: "allocation table"
  }), isLoading ? /*#__PURE__*/React.createElement(Paper, {
    className: classes.pageTabsPaper
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  })) : /*#__PURE__*/React.createElement("div", null, !fromHistory && /*#__PURE__*/React.createElement(AllocationsActionBar, {
    disabled: disabled,
    handleAddAdditionalCycle: () => setAddTable(true),
    propertyId: propertyId
  }), /*#__PURE__*/React.createElement(PageTabs, {
    tabs: tabs,
    selectedTab: selectedBillingCycleId || allocationCycleId,
    handleSelectedTabChange: handleSelectedTabChange
  })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, {
    className: classes.lgSection
  }, isLoading || isTableLoading ? /*#__PURE__*/React.createElement(TableLoader, null) : /*#__PURE__*/React.createElement(React.Fragment, null, store.account.featureFlagsStore.allocationCorrectionEnabled && store.corrections.hasCorrectionsDetails ? /*#__PURE__*/React.createElement(CorrectionsTable, {
    allocationCycleId: allocationCycleId,
    fromHistory: fromHistory
  }) : null, utilityTables.map(utility => /*#__PURE__*/React.createElement(AllocationUtility, {
    allocationMethod: utility.allocationMethod,
    billStatus: utility.billStatus,
    cycleId: allocationCycleId,
    expanded: expanded,
    fromHistory: fromHistory,
    key: utility.utilityId + utility.billStatus,
    isEditable: utility.isEditable,
    isSkipped: utility.isSkipped,
    utilityId: utility.utilityId
  })), store.account.featureFlagsStore.getIsSubmeterInterimSolutionEnabled && submeteredUtilityTables.map(submUtility => /*#__PURE__*/React.createElement(AllocationSubmeteredUtility, {
    allocationMethod: submUtility.allocationMethod,
    billStatus: submUtility.billStatus,
    cycleId: allocationCycleId,
    expanded: expanded,
    fromHistory: fromHistory,
    key: submUtility.utilityId,
    isSkipped: submUtility.isSkipped && !fromHistory,
    utilityId: submUtility.utilityId
  })), /*#__PURE__*/React.createElement(Separator, {
    text: t('allocations.summary')
  }), /*#__PURE__*/React.createElement("div", {
    "data-tut": "reactour__allocation-summary"
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.allocations.getAllocationTableAggregateAsync.inProgress
  }), /*#__PURE__*/React.createElement(AllocationsSummary, null)))))), /*#__PURE__*/React.createElement(AllocationHistoryModal, null), /*#__PURE__*/React.createElement(ConfirmTableClosingModal, {
    isOpen: tableId,
    onConfirm: () => setDeleteTableId(tableId),
    setTableId: setTableId
  }), true ? null : /*#__PURE__*/React.createElement(ReportCredentialsIssueModal, null));
});
export default AllocationTablesPage;